import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const SettingsLastActivities = (props) => {
  const { t } = useTranslation();

  return (
    <div className="settings-groups">
      <div className="settings-name">
        {t("dashboard.letzteBenutzeraktivitaeten")}
      </div>
      <table id="letzteBenutzeraktivitaeten">
        <thead>
          <th>{t("allgemein.benutzer")}</th>
          <th>{t("allgemein.aenderung")}</th>
          <th>{t("allgemein.zeitstempel")}</th>
        </thead>
        <tbody>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
          <td>{t("allgemein.daten")}</td>
        </tbody>
      </table>
    </div>
  );
};

export default SettingsLastActivities;
